<div *ngIf="loader; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>



<ng-template #elseBlock>
  <div class="divHome">
    <h1>Anulación de OS</h1>


    <div style="display: flex; justify-content: center">
      <mat-form-field appearance="outline" class="divInputSearch">
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar">
      </mat-form-field>
    </div>


    <div class="divButtons">

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>FILES</mat-label>
        <mat-select [(value)]="selectFile" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let file of arrayFiles" value={{file}}>{{file}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO FILE</mat-label>
        <mat-select [(value)]="selectEstadoFile" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let estadoFile of arrayEstadoFiles" value={{estadoFile}}>{{estadoFile}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CLIENTES</mat-label>
        <mat-select [(value)]="selectedCliente" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let cliente of arrayClientes" value={{cliente}}>{{cliente}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>PROVEEDOR</mat-label>
        <mat-select [(value)]="selectProveedor" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let proveedor of arrayProveedores" value={{proveedor}}>{{proveedor}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>NUM OS</mat-label>
        <mat-select [(value)]="selectOS" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let os of arrayOS" value={{os}}>{{os}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO OS</mat-label>
        <mat-select [(value)]="selectEstadoOS" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let optionSelect of arraySelectEstadoOS"
            value={{optionSelect}}>{{optionSelect}}</mat-option>
        </mat-select>
      </mat-form-field>



      <mat-form-field class="buttonFilterFecha">
        <mat-label> FECHA DE CREACIÓN</mat-label>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Inicio" [(ngModel)]="startDate">
          <input matEndDate placeholder="Fin" [(ngModel)]="endDate">
        </mat-date-range-input>
        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button style="background-color: rgb(184, 69, 18);" mat-raised-button color="primary"
              (click)="onApplyRangeSelected()" matDateRangePickerApply>Filtrar</button>
            <button mat-button matDateRangePickerCancel (click)="cleanDateSelected(1)"> Limpiar</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="buttonFilterFecha">
        <mat-label> FECHA PAGO</mat-label>
        <mat-datepicker-toggle matSuffix [for]="rangePicker2"></mat-datepicker-toggle>
        <mat-date-range-input [rangePicker]="rangePicker2">
          <input matStartDate placeholder="Inicio" [(ngModel)]="startDate2">
          <input matEndDate placeholder="Fin" [(ngModel)]="endDate2">
        </mat-date-range-input>

        <mat-date-range-picker #rangePicker2>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>Cancel</button>
            <button style="background-color: rgb(184, 69, 18);" mat-raised-button color="primary"
              (click)="onApplyRangeSelected2()" matDateRangePickerApply>Filtrar</button>
            <button mat-button matDateRangePickerCancel (click)="cleanDateSelected(2)"> Limpiar</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>


    </div>


    <div class="example-container mat-elevation-z8" *ngIf="osDataSource">

      <mat-table [dataSource]="osDataSource" matSort>

        <ng-container matColumnDef="estadoFile">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> ESTADO FILE </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.estadoFile ? row.estadoFile : '-'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> FILE </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.numberFile}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="moneda">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> MONEDA </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.moneda}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numberOS">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> NÚMERO OS </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.numberOS}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoOS">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> ESTADO OS </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{traslateEstado(row.estadoOS)}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nameEmpresa">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> CLIENTE </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.nameEmpresa}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="nameProveedor">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> PROVEEDOR </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.nameProveedor}} </mat-cell>
        </ng-container>


<!--         <ng-container matColumnDef="numPAX">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> PAX </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row?.cantPax}} </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> FECHA CREACIÓN </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.createdAt | date:'dd/MM/yyyy'}} </mat-cell>
        </ng-container>


        <!--        <ng-container matColumnDef="razonSocialProveedor">-->
        <!--          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> RAZÓN SOCIAL </mat-header-cell>-->
        <!--          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.razonSocialProveedor}} </mat-cell>-->
        <!--        </ng-container>-->


        <ng-container matColumnDef="fechaPago">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> FECHA DE PAGO </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{row.fechaPago | date:'dd/MM/yyyy'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="monto">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle"> MONTO </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> {{ row.monto | formatNumber }} </mat-cell>
        </ng-container>



        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="headerStyle">ANULAR</mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle"> <button mat-icon-button color="primary"><mat-icon
                (click)="openDialog(row)" class="icon-color">backspace</mat-icon></button>
          </mat-cell>

        </ng-container>


        <mat-header-row *matHeaderRowDef="osDisplayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: osDisplayedColumns;">
        </mat-row>
      </mat-table>

    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>
  </div>



</ng-template>